export default function Loading({word="Loading", className=""}) {
  return (
    <div className={`loading-overlay ${className}`}>
      <div className="spinner" />
      <p className="loading-text">{word}</p>
    </div>
  )
}